var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhBannerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3167 0C16.4988 0.911651 16.5942 1.85306 16.5942 2.81595C16.5942 10.9919 9.72158 17.6198 1.24379 17.6198C0.825074 17.6198 0.410253 17.6035 0 17.5718V11.8293C5.12943e-06 9.7944 1.12569 7.91411 2.95299 6.89667L14.0353 0.726151C14.748 0.329294 15.5253 0.0872642 16.3167 0Z",
    fill: "#F2892F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7163 0.00338745C18.4963 0.0936908 19.2618 0.334355 19.9647 0.725679L31.0469 6.8962C32.8742 7.91364 33.9999 9.79393 33.9999 11.8288V17.5725C33.5952 17.6034 33.1861 17.6193 32.7732 17.6193C24.3049 17.6193 17.4399 10.9914 17.4399 2.81548C17.4399 1.85395 17.5349 0.913833 17.7163 0.00338745Z",
    fill: "#218DC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24379 18.4131C9.72158 18.4131 16.5942 25.0336 16.5942 33.2004C16.5942 34.1576 16.4997 35.0936 16.3194 36.0001C15.527 35.9131 14.7488 35.671 14.0353 35.2737L2.95299 29.1032C1.12569 28.0857 5.33791e-06 26.2054 0 24.1706V18.461C0.410252 18.4293 0.825076 18.4131 1.24379 18.4131Z",
    fill: "#5E910D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7506 18.4131C33.1635 18.4131 33.5726 18.4289 33.9773 18.4599V24.1706C33.9773 26.2054 32.8516 28.0857 31.0243 29.1032L19.942 35.2737C19.2373 35.6661 18.4695 35.9069 17.6873 35.9967C17.5101 35.0963 17.4173 34.1671 17.4173 33.2169C17.4173 25.041 24.2822 18.4131 32.7506 18.4131Z",
    fill: "#8EBC29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhBannerLogo);
export default __webpack_public_path__ + "static/media/PH_Banner_Logo.d63a5ecf6533410841012864e3a9de77.svg";
export { ForwardRef as ReactComponent };